<template>
    <div class="text-[28px] font-bold tracking-tighter">
        {{ text }}
    </div>
</template>
<script>
export default {
    name: "frontend-header-h2",
    props: {
        text: {
            type: String,
            default: "",
        },
    },
};
</script>
